interface TestIdOptions {
	c?: string; // code
	i?: number; // index
	j?: number; // journeyIndex
	p?: number; // paxIndex
	m?: boolean; // isMobile
}

const NAME_SEPARATOR = "--";
const SEPARATOR = "-";
const MOBILE_PREFIX = "m|";
const JOURNEY_INDEX_PREFIX = "j|";
const PAX_INDEX_PREFIX = "p|";
const INDEX_PREFIX = "i|";
const CODE_PREFIX = "c|";

export const getTestId = (name: string, options: TestIdOptions): string => {
	let retVal = "";
	retVal += options.j !== undefined ? `${retVal ? SEPARATOR : ""}${JOURNEY_INDEX_PREFIX}${options.j}` : "";
	retVal += options.p !== undefined ? `${retVal ? SEPARATOR : ""}${PAX_INDEX_PREFIX}${options.p}` : "";
	retVal += options.c !== undefined ? `${retVal ? SEPARATOR : ""}${CODE_PREFIX}${options.c}` : "";
	retVal += options.i !== undefined ? `${retVal ? SEPARATOR : ""}${INDEX_PREFIX}${options.i}` : "";
	retVal += options.m === true ? `${retVal ? SEPARATOR : ""}${MOBILE_PREFIX}1` : "";

	return [name, retVal].filter((i) => i).join(NAME_SEPARATOR);
};

export const decodeTestId = (id: string) => {
	const [name, rest] = id.split(NAME_SEPARATOR);
	const args = rest.split(SEPARATOR);

	const journeyIndex = args.find((a) => a.startsWith(JOURNEY_INDEX_PREFIX))?.substring(JOURNEY_INDEX_PREFIX.length);
	const paxIndex = args.find((a) => a.startsWith(PAX_INDEX_PREFIX))?.substring(PAX_INDEX_PREFIX.length);
	const code = args.find((a) => a.startsWith(CODE_PREFIX))?.substring(CODE_PREFIX.length);
	const index = args.find((a) => a.startsWith(INDEX_PREFIX))?.substring(INDEX_PREFIX.length);
	const isMobile = args.some((a) => a.startsWith(MOBILE_PREFIX));

	return { name, journeyIndex, paxIndex, code, index, isMobile };
};
